import React from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Button } from "@/uiKit/atoms/Button.tsx";
import { CardFooter } from "@/uiKit/atoms/CardFooter.tsx";
import {
  CarePlanRenewalInfo,
  SimpleCarePlanRenewalInfo,
} from "@/uiKit/organisms/PatientCreationAndRenewal/CarePlan/CarePlanRenewal.ts";
import { CARE_PLAN_RENEWAL_FORM_ID } from "@/uiKit/organisms/PatientCreationAndRenewal/CarePlan/CarePlanRenewalForm.tsx";

export type CarePlanRenewalFormActionsProps = {
  onBack?: (data: Partial<CarePlanRenewalInfo>) => void;
  className?: string;
};

export const CarePlanRenewalFormActions: React.FC<CarePlanRenewalFormActionsProps> = ({ onBack, className }) => {
  const formContext = useFormContext<SimpleCarePlanRenewalInfo>();
  const { t } = useTranslation();

  return (
    <CardFooter className={className}>
      <Button
        variant="outlined"
        data-action="patient-creation.care-plan-renewal.previous"
        id="care-plan-renewal-cancel"
        onClick={() => onBack && onBack(formContext.getValues() as CarePlanRenewalInfo)}
      >
        {t("button.back")}
      </Button>
      <Button
        form={CARE_PLAN_RENEWAL_FORM_ID}
        id="care-plan-renewal-next"
        type="submit"
        variant="contained"
        data-action="patient-creation.care-plan-renewal.next"
      >
        {t("button.next")}
      </Button>
    </CardFooter>
  );
};
